<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Konfiguration Zwei-Faktor-Authentifizierung"}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-12">
{{#if mfa_activation}}
			<div class="alert alert-info">{{TR "Zur Anmeldung ist eine Zwei-Faktor-Authentifizierung erforderlich."}}</div>
{{/if}}
			<p>{{TR "SAM DISTRICT ENERGY unterstützt die Authentifizierung mittels RFC 6238 TOTP (Time-Based One-Time Password) Verfahren."}}</p>
			<p>{{TR "Dazu wird ein Smartphone mit entsprechender App benötigt. Je nach Modell existieren verschiedene Apps die zur Authentifizierung verwendet werden können (z.B. Google Authenticator, Microsoft Authenticator oder Authy). Bitte installieren Sie eine passende App bevor sie fortfahren."}}</p>
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12">
			<p>{{TR "Scannen Sie den QR-Code in Ihrer App und geben Sie anschließend den angezeigten (sechsstelligen) Zahlencode ein um die Zwei-Faktor-Authentifizierung zu aktivieren."}}</p>
			<p><strong>{{TR "Stellen Sie unbedingt sicher, dass kein Unbefugter den QR-Code abscannen kann!"}}</strong></p>
			<center>
				<icon class="fa fa-qrcode" />&nbsp;<a data-toggle="collapse" href="#qr-code"><u class="m-t-5 error-plain">{{TR 'Persönlichen QR-Code anzeigen.'}}</u></a><br>
				<img id="qr-code" class="collapse" src="api/v1/account/mfa"></img>
			</center>
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12 col-sm-4 col-sm-offset-4 m-t-5">
			<div class="form-group">
				<input type="number" class="form-control m-t-5" id="js-code" name="code" placeholder="{{TR "2FA Code"}}" value="{{code}}">
				{{#if error}}
				<ul class="parsley-errors-list filled" id="js-code-error">
					<li class="parsley-required">{{error}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12 m-t-5">
			<p>{{TR "Nach Aktivierung benötigen Sie für jeden Login zusätzlich den Zahlencode der App."}}</p>
		</div>
	</div>
</div>
<div class="modal-footer">
{{#if mfa_active}}
	<button id="js-delete" class="btn btn-white pull-left">{{TR "2FA deaktivieren"}}</button>
{{/if}}
	<button id="js-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{TR "2FA aktivieren"}}</button>
</div>
